/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { SlugFor } from 'app/shared/model/enumerations/slug-for.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface IUrlSlug {
  id?: string;
  slug?: string;
  originalUrl?: string;
  createdDate?: number | null;
  timeToLive?: number | null;
  secret?: string | null;
  createdFor?: keyof typeof SlugFor | null;
  entityType?: keyof typeof EntityType | null;
  entityId?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
}

export const defaultValue: Readonly<IUrlSlug> = {
  active: false,
};
